var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircleThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WarningCircle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WarningCircle_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42Z",
    stroke: "#424242",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24 15V25.5",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24 33.6002C24.6628 33.6002 25.2 33.0629 25.2 32.4002C25.2 31.7375 24.6628 31.2002 24 31.2002C23.3373 31.2002 22.8 31.7375 22.8 32.4002C22.8 33.0629 23.3373 33.6002 24 33.6002Z",
    fill: "#424242"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleThin);
export default __webpack_public_path__ + "static/media/warning-circle-thin.93e3a3c6e979d697a7eae32969245a27.svg";
export { ForwardRef as ReactComponent };